/** @format */

import { useLocation } from "react-router-dom";

export const useNavgatePath = (path: string, redirect: Boolean = false) => {
  const location = useLocation();
  let navigateTo = "";
  const navigatePath = redirect ? "/redirect" : "/entry";
  const confirmPath = redirect ? "/redirect_password" : "/entry_confirm";
  const redirectPath = redirect ? "/redirect_confirm" : "/entry_confirm";
  switch (path) {
    case "merchant":
      navigateTo = navigatePath + "/bank_account";
      break;
    case "bank_account":
      navigateTo = navigatePath + "/shop";
      break;
    case "shop":
      navigateTo = confirmPath;
      break;
    default:
      break;
  }
  if (location.state && location.state.confirm_flag) navigateTo = redirectPath;
  return { navigateTo };
};
